<template>
  <div class="rc-file-design">
    <label class="item-name">{{initComponent.name}}</label>
    <i class="el-icon-upload i"></i>
  </div>
</template>

<script>
import {componentMixin} from '../mixins'

export default {
  name: 'rc-file',
  props: ['initComponent'],
  mixins: [componentMixin],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>

<style lang="scss">
  .rc-file-design {
    & > .i {
      font-size: 35px;
      border: 1px solid #c2c3c4;
      border-radius: 4px;
      margin-top: 4px;
      color: #3a8ee6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/file/rc-file.vue